/* eslint-disable @wix/da/import-scss-last */
// project-base needs to go before app styles
import '@wix/da-ds/src/styles/project-base.scss';
import Modal from 'react-modal';
import initI18n from '@wix/da-i18next/pkg/presetI18nClientConfig';
import { getClientInstance } from '@wix/da-ddt';
import { configureStore } from './redux/store/configure-store';
import App from './components/contactUs/App';
import { hydrateRoot } from 'react-dom/client';
import { getEnv } from '@wix/da-react-app/pkg/client/Environment/redux/selectors';
import AppDocumentWrapper from '@wix/da-react-app/pkg/client/AppDocumentWrapper';

const ddt = getClientInstance();
ddt.replayServerSideLogs(window['__DDT__']);

const initialState = window['__INITIAL_STATE__'];
delete window['__INITIAL_STATE__'];
const initialI18n = window['__INITIAL_I18N__'];

const store = configureStore(initialState);

initI18n(
  initialI18n,
  getEnv(store.getState()).isDebug,
  getEnv(store.getState()).flags
);

Modal.setAppElement('body');
hydrateRoot(
  document,
  <AppDocumentWrapper store={store}>
    <App language={initialI18n.locale} />
  </AppDocumentWrapper>
);
